import { useCallback } from 'react';
import { type HeadlineFieldValue } from '@gorilla/portal-shared/src/schemas';
import { type HeadlineFieldDescriptor } from '@gorilla/portal-shared/src/types';
import { TextField, Box, Flex, Label, Text } from '@vibe/core';
import { dropdownValue } from '@gorilla/ui/src/components/dropdownValue';
import { Dropdown } from '@vibe/core';
import { Paste, Apps } from '@vibe/icons';

const HEADLINE_OPTIONS = [
  {
    value: 1,
    label: 'Large',
    color: 'dark',
  },
  {
    value: 2,
    label: 'Medium',
    color: 'dark',
  },
  {
    value: 3,
    label: 'Small',
    color: 'dark',
  },
];

type HeadlineFieldProps = {
  value: HeadlineFieldValue;
  fieldDescriptor: HeadlineFieldDescriptor;
  onChange: (value: HeadlineFieldValue) => void;
  onShowPlaceholdersModalClick: (insertHandler?: (placeholder: string) => void) => void;
};

export function HeadlineField({ value, fieldDescriptor, onChange, onShowPlaceholdersModalClick }: HeadlineFieldProps) {
  let normalizedValue = value || { headline: '', level: 1 };

  if (!normalizedValue.level) {
    normalizedValue.level = 1;
  }

  if (!normalizedValue.headline) {
    normalizedValue.headline = '';
  }

  let selectedHeadlineType = HEADLINE_OPTIONS.find((option) => option.value === normalizedValue.level);

  if (!selectedHeadlineType) {
    selectedHeadlineType = HEADLINE_OPTIONS[0];
  }

  const labelRenderer = useCallback(({ label }: { value: any; label: any; color: any }) => {
    return <Flex gap={8}>{label}</Flex>;
  }, []);

  return (
    <Box className="section__field section__field--headline">
      <Flex direction="row" align="end" gap={16}>
        <Box style={{ flex: 1 }}>
          <TextField
            size="medium"
            title={fieldDescriptor.title}
            value={normalizedValue.headline}
            onChange={(newHeadline: string) => {
              onChange({ ...normalizedValue, headline: newHeadline });
            }}
            icon={fieldDescriptor.placeholdersSupport ? Apps : undefined}
            onIconClick={
              fieldDescriptor.placeholdersSupport
                ? () => {
                    onShowPlaceholdersModalClick((placeholder: string) => {
                      const base = normalizedValue?.headline ?? '';
                      const next = {
                        ...(normalizedValue || {}),
                        headline: `${base}${placeholder}`,
                      };
                      onChange(next);
                    });
                  }
                : undefined
            }
          />
        </Box>
        <Box style={{ minWidth: '170px' }}>
          <Box style={{ paddingBottom: '4px' }}>
            <Text type="text2" color="primary" style={{ padding: '2px 0' }}>
              Headline size
            </Text>
          </Box>
          <Dropdown
            placeholder="Choose type"
            size="medium"
            clearable={false}
            searchable={false}
            value={dropdownValue(selectedHeadlineType)}
            options={HEADLINE_OPTIONS}
            optionRenderer={labelRenderer}
            valueRenderer={labelRenderer}
            onChange={(newHeadlineType: any) => {
              onChange({ ...normalizedValue, level: newHeadlineType.value });
            }}
            //className="custom_dropdown"
          />
        </Box>
      </Flex>
    </Box>
  );
}
